import React, { useState } from "react";
import {
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  TablePagination,
} from "@mui/material";
import { MdAdd, MdDelete, MdEdit } from "react-icons/md";
import axios from "axios";
import { Link } from "react-router-dom";
import {
  useGetUsersQuery,
  useRemoveUserMutation,
} from "../../features/api/userApi";
import { FaEdit } from "react-icons/fa";
import { API_BASE_URL } from "../../components/baseUrl";

const Users = () => {
  const { data, isLoading } = useGetUsersQuery(null, {
    refetchOnMountOrArgChange: true,
  });
  const users = data?.users;

  const [removeUser] = useRemoveUserMutation();
  const handleDelete = async (id) => {
    const confirm = window.confirm("Are Your Sure?");
    if (confirm) {
      try {
        const response = await removeUser(id);

        if (response) {
          console.log(response);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  return (
    <div className="px-12">
      <div className="flex justify-between items-center py-6">
        <h1 className="text-xl font-bold">User Management</h1>
        <Link to="/dashboard/user/create">
          <span className=" text-white bg-blue-500 font-medium cursor-pointer flex items-center px-1">
            <MdAdd /> Create User
          </span>
        </Link>
      </div>
      <div className="">
        {isLoading ? (
          <div className="w-fll h-screen flex flex-col items-center justify-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900"></div>
          </div>
        ) : users?.length === 0 ? (
          <p className=" text-xl text-red-500">There are no more users</p>
        ) : (
          <TableContainer component={Paper}>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell style={{ backgroundColor: "#f0f0f5" }}>
                    <span className="font-bold">Sl No.</span>
                  </TableCell>
                  <TableCell style={{ backgroundColor: "#f0f0f5" }}>
                    <span className="font-bold">User Role</span>
                  </TableCell>
                  <TableCell style={{ backgroundColor: "#f0f0f5" }}>
                    <span className="font-bold">Name</span>
                  </TableCell>
                  <TableCell style={{ backgroundColor: "#f0f0f5" }}>
                    <span className="font-bold">Email</span>
                  </TableCell>
                  <TableCell style={{ backgroundColor: "#f0f0f5" }}>
                    <span className="font-bold">Signature</span>
                  </TableCell>
                  <TableCell style={{ backgroundColor: "#f0f0f5" }}>
                    <span className="font-bold">Action</span>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {users
                  ?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  ?.map((row, i) => (
                    <TableRow key={row.id}>
                      <TableCell>{i + 1}</TableCell>
                      <TableCell>{row.role}</TableCell>
                      <TableCell>{row.name}</TableCell>
                      <TableCell>{row.email}</TableCell>
                      <TableCell>
                        <img
                          src={`${API_BASE_URL}/uploads/${row?.signature}`}
                          alt=""
                          className="w-12 h-12"
                        />
                      </TableCell>
                      <TableCell className="">
                        <div className="flex items-center gap-x-4">
                          <Link to="/dashboard/user/edit" state={row}>
                            <span>
                              <FaEdit className="text-xl text-blue-500 font-bold cursor-pointer" />
                            </span>
                          </Link>
                          {/* <span onClick={() => handleDelete(row?.id)}>
                            <MdDelete className="text-xl text-red-500 font-bold cursor-pointer" />
                          </span> */}
                        </div>
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
            <TablePagination
              style={{ backgroundColor: "#f0f0f5" }}
              rowsPerPageOptions={[5, 10, 25]}
              component="div"
              count={users?.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </TableContainer>
        )}
      </div>
    </div>
  );
};

export default Users;
